export const STRICT_WS = 'STRICT_WS';
export const STRICT_WS_SUCCESS = 'STRICT_WS_SUCCESS';
export const STRICT_WS_ERROR = 'STRICT_WS_ERROR';
